import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";

// initial state

const state = {
  notifications: [],
  acls: [],
  myacls: [],
  recordsiamauthorizedon: []
};

export default {
  state,
  getters,
  actions,
  mutations
};
